/** @prettier */
// @flow
import { getCountryCode } from '../../helpers/common';
import { getInstance } from '../../helpers/gdpr';
import { hideGdprConsent } from '../../landingAPI/hideGdprConsent';

export default () => {
  const button = document.querySelector('[data-privacy-settings-button]');
  if (!button) {
    return;
  }
  button.addEventListener('click', () => {
    const app = getInstance();
    if (app) {
      app.show();
    }
  });

  const isUSA = getCountryCode() === 'US';
  const privacySettingsContainer = document.querySelector(
    '.ui-site-privacy-settings-button'
  );

  if (isUSA) {
    const privacySettingsButton = document.querySelector(
      '[data-privacy-settings-button-text]'
    );
    const USAPrivacySettingsButton = document.querySelector(
      '[data-privacy-settings-button-usa-text]'
    );
    if (!privacySettingsButton || !USAPrivacySettingsButton) {
      return;
    }

    privacySettingsButton.hidden = true;
    USAPrivacySettingsButton.hidden = false;
  }

  if (hideGdprConsent() && privacySettingsContainer) {
    privacySettingsContainer.classList.remove(
      'ui-site-privacy-settings-button'
    );
    privacySettingsContainer.classList.add(
      'ui-site-privacy-settings-button_hidden'
    );
  }
};
